import { QueryCache, QueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { toast } from 'sonner'

import getGeneralErrorMessage from './errors/getGeneralErrorMessage'

declare module '@tanstack/react-query' {
  interface Register {
    defaultError: unknown
  }
}

const DEFAULT_STALE_TIME_MS = 30_000
const MAX_QUERY_RETRIES = 2
const FIRST_SERVER_ERROR_STATUS = 500

export const shouldRetryQuery = (failureCount: number, error: unknown) => {
  if (error instanceof AxiosError) {
    const status = error.response?.status
    if (status !== undefined && status < FIRST_SERVER_ERROR_STATUS) return false
  }
  return failureCount < MAX_QUERY_RETRIES
}

export const createQueryClient = () =>
  new QueryClient({
    queryCache: new QueryCache({
      onError: (error, query) => {
        if (query.state.data !== undefined) {
          toast.error(getGeneralErrorMessage(error))
        }
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: DEFAULT_STALE_TIME_MS,
        retry: shouldRetryQuery,
      },
    },
  })

export const queryClient = createQueryClient()
